import { IconButton } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import React, { useState } from "react";
import { Row, Col, Input, InputGroup, InputGroupAddon, InputGroupText, ModalBody,
  Modal,
  ModalFooter,
  FormFeedback,
  ModalHeader} from "reactstrap";
import moment from 'moment';
import Button from "@material-ui/core/Button";
import { isEmpty, size, isUndefined, filter } from "lodash";
import {deleteFL142AssetsCall} from "../fl-142/FL142.actions";
import { connect } from "react-redux";

function FL142Section(props) {

  const [inputFields, setInputField] = useState(props.data);

  const [showNote, setShowNote] = useState(false);
  const handleShowNote = () => setShowNote(true);
  const handleCloseNote = () => setShowNote(false);

  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.id] = event.target.value;
    setInputField(values);

  }

  const handleAddFields = () => {
    setInputField(prevFields => {
      const newFields = [
        ...prevFields,
        {
          asset_description: "",
          asset_sep_prop: "",
          asset_date_acquired: "",
          asset_cgfmv: "0.0",
          asset_amoe: "0.0"
        }
      ];
      props.addField(newFields);
      return newFields;
    });
  };  

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    console.log(values,"tttttttttttttttttttttt")
    setInputField(values);
    props.addField(values);
  }

  const handleRest = (index) => {
    const values = [...inputFields];
    values[index].asset_description = "";
    values[index].asset_sep_prop = "";
    values[index].asset_date_acquired = "";
    values[index].asset_cgfmv = "0.0";
    values[index].asset_amoe = "0.0";
    setInputField(values);
    props.addField(values);
  }

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        borderTop: "2px solid",
        color: "black",
      }}
    />
  );

  const deleteCall = (id, description, descriptionId) => {
    const fallbackItem = Array.isArray(props.data)
      ? props.data.find(x => x.asset_description === description)
      : null;
  
    if ((isUndefined(id) || isUndefined(descriptionId)) && !fallbackItem) {
      console.error("No matching item found in props.data for description:", description);
      return;
    }
  
    props.deleteFL142AssetsCall({
      divorce_id: window.localStorage.getItem("divorce_id"),
      fl_142_asset_debit_id: isUndefined(id) && fallbackItem ? fallbackItem.fl_142_asset_debit_id : id,
      asset_brief_description_id: isUndefined(descriptionId) && fallbackItem ? fallbackItem.asset_brief_description_id : descriptionId,
    });
  };
  
  const getButtonValue = (e, size) => {
    switch (e) {
      case 1:
        return size < 13 ? true : false;
      case 2:
        return size < 6 ? true : false;
      case 3:
        return size < 3 ? true : false;
      case 4:
        return size < 13 ? true : false;
      case 5:
        return size < 6 ? true : false;
      case 6:
        return size < 3 ? true : false;
      case 7:
        return size < 5 ? true : false;
      case 8:
        return size < 4 ? true : false;
      case 9:
        return size < 4 ? true : false;
      case 10:
        return size < 4 ? true : false;
      case 11:
        return size < 5 ? true : false;
      case 12:
        return size < 6 ? true : false;
      case 13:
        return size < 5 ? true : false;
      case 14:
        return size < 5 ? true : false;
      case 15:
        return size < 5 ? true : false;
      case 16:
        return size < 8 ? true : false;

      default:
        return false;
    }
  }


    const showModal = (e, size) => {
    switch (e) {
      case 1:
        if(size === 12){
          handleShowNote()
        }
        break;
      case 2:
      if(size === 5){
          handleShowNote()
        }
        break;
      case 3:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 4:
      if(size === 12){
          handleShowNote()
        }
        break;
      case 5:
      if(size === 5){
          handleShowNote()
        }
        break;
      case 6:
      if(size === 2){
          handleShowNote()
        }
        break;
      case 7:
      if(size === 4){
          handleShowNote()
        }
        break;
      case 8:
      if(size === 3){
          handleShowNote()
        }
        break;
      case 9:
      if(size === 3){
          handleShowNote()
        }
        break;
      case 10:
      if(size === 3){
          handleShowNote()
        }
        break;
      case 11:
      if(size === 4){
          handleShowNote()
        }
        break;
      case 12:
      if(size === 5){
          handleShowNote()
        }
        break;
      case 13:
      if(size === 4){
          handleShowNote()
        }
        break;
      case 14:
      if(size === 4){
          handleShowNote()
        }
        break;
      case 15:
      if(size === 4){
          handleShowNote()
        }
        break;
      case 16:
      if(size === 7){
          handleShowNote()
        }
        break;

      default:
        return false;
    }
  }

  const forInvalidCondition = (value) => {
    if(inputFields.length === 1 && inputFields[0].asset_description == "" && inputFields[0].asset_sep_prop == "" && (inputFields[0].asset_date_acquired == "" || inputFields[0].asset_date_acquired == "1947-01-01")){
      return false;
    } else if(inputFields.length > 0 && value == ""){
      return true;
    }
    return false;
  }

  return (
    <div>
      {!isEmpty(inputFields) && inputFields.map((input, index) => (
        <div key={index} >

          <Row>
            <Col xl={6}>
              <b>Asset Description:</b>
            </Col>
            <Col xl={12}>
              <Input style={{ marginLeft: "2px" }} value={input.asset_description} type="text" id="asset_description" invalid={forInvalidCondition(input.asset_description)}
                onChange={(e) => {props.handleDescriptionChange(inputFields); handleChangeInput(index, e) }}
              />
              <FormFeedback>This field is required.</FormFeedback>
            </Col>
          </Row>

          <Row>
            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <br></br>
              <b>Separate Property:</b>

              <Input value={input.asset_sep_prop} type="select" id="asset_sep_prop"
                invalid={forInvalidCondition(input.asset_sep_prop)}
                onChange={(e) => {props.handleSeparatePropertyChange(inputFields); handleChangeInput(index, e) }}
                style={
                  input.asset_sep_prop == ""
                    ? { backgroundImage: "none" } 
                    : {}
                }
              >
              <option value = ""> -- select an option -- </option>
              <option value="1">Yes</option>
              <option selected value="0">No</option>
              </Input>
              <FormFeedback>This field is required.</FormFeedback>
            </Col>

            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <br></br>
              <b>Date Acquired:</b>

              <Input value={(input.asset_date_acquired == "1947-01-01") ? "" : moment(input.asset_date_acquired).format('YYYY-MM-DD')} type="date" id="asset_date_acquired"
                invalid={forInvalidCondition(input.asset_date_acquired)}
                onChange={(e) => {props.handleDateAcquiredChange(inputFields); handleChangeInput(index, e) }}
              />
              <FormFeedback>This field is required.</FormFeedback>
            </Col>

          </Row>

          <Row>
            <Col xl={6} lg={6} md={12} sm={12}>
              <br></br>
              <br></br>
              <b>Current Gross Fair Market Value:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input value={input.asset_cgfmv} type="number" id="asset_cgfmv"
                onChange={(e) => {props.handleGrossFairChange(inputFields); handleChangeInput(index, e) }}
              />
              </InputGroup>
            </Col>

            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
              <br></br>
              <b>Amount of Money Owed or Encumbrance:</b>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input value={input.asset_amoe} type="number"   id="asset_amoe"
                onChange={(e) => {props.handleMoneyOwedChange(inputFields); handleChangeInput(index, e) }} 
                />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              {inputFields.length == 1 ?
              (<IconButton onClick={() => {handleRest(index); deleteCall(input.fl_142_asset_debit_id, input.asset_description, input.asset_brief_description_id)}} style={{ float: "right", color: "black", marginTop: "15px" }} >
                <RemoveIcon />
              </IconButton>)
              :(
              <IconButton onClick={() => {handleRemoveFields(index); deleteCall(input.fl_142_asset_debit_id, input.asset_description, input.asset_brief_description_id)}} style={{ float: "right", color: "black", marginTop: "15px" }} >
                <RemoveIcon />
              </IconButton>
              )}

              {getButtonValue(props.descriptionId, size(inputFields)) && <IconButton onClick={() => {handleAddFields(); showModal(props.descriptionId, size(inputFields))}} style={{ float: "right", color: "black", marginTop: "15px" }}>
                <AddIcon />
              </IconButton>}
            </Col>
          </Row>
          <ColoredLine />
        </div>
      ))}
      <Modal isOpen={showNote} style={{ marginTop: "200px", marginLeft: "46%" }}>
        <ModalHeader>
        Note:
        </ModalHeader>
        <ModalBody> If you do not have the options to add more, the court form has run out
           of space. You will need to add a separate attachment. Watch your video tutorials
            for more details.
        </ModalBody>
        <ModalFooter>
        <Row style={{marginLeft:"3px"}}>
        <Button
          style={{width:"48%",marginRight:"2px", color: "white", backgroundColor: "Blue" }}
          onClick={handleCloseNote}
        >
          OK
        </Button>
        </Row>
        </ModalFooter>
      </Modal>
    </div>
  );
}


const mapDispatchToProps = (dispatch) => {
  return {
    deleteFL142AssetsCall: (data) => dispatch(deleteFL142AssetsCall(data)),
  }
}


export default connect(null, mapDispatchToProps)(FL142Section);
